<template>
  <div class="rc-router-type">
    <rc-router-link class="router" :data="routerData"></rc-router-link>
  </div>
</template>

<script>
export default {
  name: "RcRouterType",
  props: {
    column: Object,
    row: Object
  },
  computed: {
    routerData() {
      const { column, row } = this;
      const { key, rowKey, data, prop } = column;
      return data || [{
        label: row[prop],
        to: { ...column, query: { [key || "id"]: row[rowKey] }}
      }];
    }
  }
};
</script>

<style lang="scss" scoped>
.router {
  cursor: pointer;
  &:hover {
    color: #00b259;
  }
}
</style>
